import Axios from "axios";
import { message } from "antd";

export default function deleteUser(_id, filterUserDeletion) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "DELETE",
      url: `${process.env.REACT_APP_BASE_URL}/deleteUser/${_id}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then(() => {
        if (filterUserDeletion) {
          filterUserDeletion(_id);
        }
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch(() => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        message.error("Something Went Wrong Please try again Later");
      });
  };
}
